import React, { useState } from "react";

const FeedbackToggle = ({ defaultValue = null, onChange }) => {
  const [feedback, setFeedback] = useState(defaultValue); // 'like' | 'dislike' | null

  const handleClick = (type) => {
    const newValue = feedback === type ? null : type;
    setFeedback(newValue);
    onChange?.(newValue);
  };

  return (
    <ul className="like-suggestion">
      <li>
        <button
          type="button"
          className={feedback === "like" ? "active" : ""}
          onClick={() => handleClick("like")}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.88235 5.49895V9.49774C3.88235 9.63031 3.83277 9.75745 3.74452 9.85119C3.65627 9.94493 3.53657 9.99759 3.41176 9.99759H2.47059C2.34578 9.99759 2.22608 9.94493 2.13783 9.85119C2.04958 9.75745 2 9.63031 2 9.49774V5.9988C2 5.86623 2.04958 5.73909 2.13783 5.64535C2.22608 5.55161 2.34578 5.49895 2.47059 5.49895H3.88235ZM3.88235 5.49895C4.38158 5.49895 4.86037 5.2883 5.21338 4.91334C5.56639 4.53838 5.76471 4.02982 5.76471 3.49955V2.9997C5.76471 2.73456 5.86387 2.48028 6.04037 2.29281C6.21688 2.10533 6.45627 2 6.70588 2C6.9555 2 7.19489 2.10533 7.37139 2.29281C7.5479 2.48028 7.64706 2.73456 7.64706 2.9997V5.49895H9.05882C9.30844 5.49895 9.54783 5.60427 9.72434 5.79175C9.90084 5.97923 10 6.23351 10 6.49865L9.52941 8.99789C9.46173 9.30454 9.33335 9.56784 9.1636 9.74815C8.99385 9.92846 8.79192 10.016 8.58824 9.99759H5.29412C4.91969 9.99759 4.56061 9.83961 4.29585 9.55839C4.03109 9.27717 3.88235 8.89575 3.88235 8.49804" stroke="#8E97A3" strokeLinecap="round" strokeLinejoin="round" fill={feedback === "like" ? "currentColor" : "none"} />
          </svg>
          Like
        </button>
      </li>

      <li>
        <button
          type="button"
          className={feedback === "dislike" ? "active" : ""}
          onClick={() => handleClick("dislike")}
        >

          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.88235 6.50105V2.50226C3.88235 2.36969 3.83277 2.24255 3.74452 2.14881C3.65627 2.05507 3.53657 2.00241 3.41176 2.00241H2.47059C2.34578 2.00241 2.22608 2.05507 2.13783 2.14881C2.04958 2.24255 2 2.36969 2 2.50226V6.0012C2 6.13377 2.04958 6.26091 2.13783 6.35465C2.22608 6.44839 2.34578 6.50105 2.47059 6.50105H3.88235ZM3.88235 6.50105C4.38158 6.50105 4.86037 6.7117 5.21338 7.08666C5.56639 7.46162 5.76471 7.97018 5.76471 8.50045V9.0003C5.76471 9.26544 5.86387 9.51972 6.04037 9.70719C6.21688 9.89467 6.45627 10 6.70588 10C6.9555 10 7.19489 9.89467 7.37139 9.70719C7.5479 9.51972 7.64706 9.26544 7.64706 9.0003V6.50105H9.05882C9.30844 6.50105 9.54783 6.39573 9.72434 6.20825C9.90084 6.02077 10 5.76649 10 5.50135L9.52941 3.00211C9.46173 2.69546 9.33335 2.43216 9.1636 2.25185C8.99385 2.07154 8.79192 1.984 8.58824 2.00241H5.29412C4.91969 2.00241 4.56061 2.16039 4.29585 2.44161C4.03109 2.72283 3.88235 3.10425 3.88235 3.50196" stroke="#8E97A3" strokeLinecap="round" strokeLinejoin="round" fill={feedback === "dislike" ? "currentColor" : "none"} />
          </svg>
          Dislike
        </button>
      </li>
    </ul>
  );
};

export default FeedbackToggle;
